<template>
  <div
    v-if="gettingFileSystem"
    class="p-4 analytics-loading"
  >
    <b-spinner variant="primary" />
  </div>
  <vue-apex-charts
    v-else
    type="line"
    :height="showLegend ? 340 : 240"
    :options="options"
    :series="series"
  />
</template>
<script>
import VueApexCharts from 'vue-apexcharts'

export default {
  name: 'FileSystemChart',
  components: { VueApexCharts },
  props: {
    showLegend: {
      type: Boolean,
      default: true,
    },
  },
  computed: {
    gettingFileSystem() {
      return this.$store.state.observability.gettingFileSystem
    },
    fileSystem() {
      return this.$store.state.observability.fileSystem
    },
    fileSystemAnalytics() {
      return this.fileSystem.length
        ? this.fileSystem[0].metrics.map(val => this.getLineChartValue(val))
        : null
    },
    firstElement() {
      return this.fileSystemAnalytics[0].value
    },
    series() {
      const series = []
      this.fileSystem.forEach(element => {
        series.push({
          data: element.metrics.map(el => el.usage),
          name: element.mount,
        })
      })
      return series
    },
    options() {
      return {
        chart: {
          id: 'fc',
          group: 'social',
          zoom: { enabled: false },
          type: 'line',
          fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", "Roboto", sans-serif',
        },
        stroke: {
          curve: 'smooth',
        },
        legend: {
          show: this.showLegend,
          position: 'bottom',
          itemMargin: {
            horizontal: 5,
            vertical: 15,
          },
        },
        colors: [
          '#DC2424',
          '#24C6DC',
          '#4A569D',
          '#514A9D',
          '#FF416C',
          '#FF4B2B',
          '#283c86',
          '#45a247',
          '#6190E8',
          '#A7BFE8',
        ],
        markers: {
          size: 0,
          hover: {
            size: 5,
          },
        },
        xaxis: {
          labels: {
            offsetY: 5,
            style: {
              fontSize: '0.857rem',
            },
            axisBorder: {
              show: false,
            },
            tickPlacement: 'on',
          },
          tickAmount: 5,
          categories: this.fileSystemAnalytics
            ? this.fileSystemAnalytics.map(el => el.name)
            : null,
        },
        yaxis: {
          labels: {
            minWidth: 40,
            style: {
              fontSize: '0.857rem',
            },
            formatter: val => `${val.toLocaleString()}%`,
          },
          min: 0,
          max: 100,
          tickAmount: 5,
        },
        tooltip: {
          followCursor: false,
        },
        noData: {
          text: 'No data available',
          align: 'center',
          verticalAlign: 'middle',
          offsetX: 0,
          offsetY: 0,
          style: {
            fontSize: '14px',
          },
        },
      }
    },
  },
  created() {
    this.id = this.$route.params.id
    this.$store.dispatch('observability/getFileSystem', this.id).catch(err => {
      console.log(err)
    })
  },
  methods: {
    getLineChartValue(el) {
      return {
        name: this.findName(el.timestamp),
        value: el.value,
      }
    },
    findName(name) {
      const d = new Date(name)
      return `${d.getHours()}:${d.getMinutes()}:${d.getSeconds()}`
    },
  },
}
</script>
